import $ from "jquery";
import HierarchySelectorNodeRenderer from "./HierarchySelectorNodeRenderer";
import {getBodyScrollTop, getBodyScrollLeft} from "../../atBrowserUtils";

export default class SimpleCheckboxNodeRenderer extends HierarchySelectorNodeRenderer {
    constructor(tree, selectorFilter, selectionHelper) {
        super(tree, selectorFilter);
        this.selectionHelper = selectionHelper;
    }

    getSpecificNodeClassName() {
        return "simpleCheckboxNode";
    }

    showNodeTooltip(tooltip, event) {
        tooltip.show();

        const tooltipInnerWidth = tooltip.width() + 1;
        tooltip.css("width", tooltipInnerWidth);

        const tooltipHeight = tooltip.outerHeight();
        const tooltipWidth = tooltip.outerWidth();

        let top = event.pageY + 13;
        if (top + tooltipHeight - getBodyScrollTop() > $(window).height())
            top = event.pageY - 13 - tooltipHeight;
        let left = event.pageX + 15;
        if (left + tooltipWidth - getBodyScrollLeft() > $(window).width())
            left = event.pageX - tooltipWidth - 15;

        tooltip.offset({top: top, left: left});
    }

    hideNodeTooltip(tooltip) {
        tooltip.hide();

        tooltip.css("width", "");
        tooltip.css("top", "");
        tooltip.css("left", "");
    }
}



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/SimpleCheckboxNodeRenderer.js